'use client';

import {createContext, type ReactNode, useContext, useState} from 'react';

interface NavigationMenuStateContextProps {
  isNavOpen: boolean;
  toggleNav: () => void;
}

const NavigationMenuStateContext = createContext<NavigationMenuStateContextProps | undefined>(
  undefined
);

export default function NavigationMenuStateProvider({children}: {children: ReactNode}) {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen((prev) => !prev);
  };

  return (
    <NavigationMenuStateContext.Provider value={{isNavOpen, toggleNav}}>
      {children}
    </NavigationMenuStateContext.Provider>
  );
}

export const useNavigationStateContext = (): NavigationMenuStateContextProps => {
  const context = useContext(NavigationMenuStateContext);

  if (!context) {
    throw new Error('useNav must be used within a NavProvider');
  }

  return context;
};
